import React from 'react'
import styled from 'styled-components'
import { Container, hooks, Spacer, Text } from 'roadie-ui'
import Icon from 'components/misc/Icon'
import ExternalLink from 'rui/widgets/ExternalLink'
import { LocalizedText } from 'localization'
import type { TranslationKey } from 'localization'

const LearnMoreButton = styled(ExternalLink)<{ backgroundColor: string; textColor: string }>`
  display: inline-block;
  width: 100%;
  padding: 1.5rem 0;
  border: none;
  border-radius: 0.5rem;
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.textColor};
`

const Oops: React.FC<{
  message: string
  url?: string
  urlText?: string
  urlTextKey?: TranslationKey
}> = (props) => {
  const { message, url, urlText, urlTextKey } = props
  const backgroundColor = hooks.useThemeColor('surface-primary-lighter')
  const textColor = hooks.useThemeColor('text-primary-dark')

  return (
    <Container.Base $textAlign="center">
      <Spacer $height="3.2rem" />
      <Icon symbol="alert" palette="white" width="8.1rem" height="8.1rem" />
      <Spacer $height="3.2rem" />
      <Text.H4>
        <LocalizedText translationKey="dweb_certifications_oops_oops" />
      </Text.H4>
      <Spacer $height="0.8rem" />
      <Text.Body2>{message}</Text.Body2>
      {url ? (
        <>
          <Spacer $height="5.3rem" />
          <LearnMoreButton href={url} backgroundColor={backgroundColor} textColor={textColor}>
            <Text.Button>{urlTextKey ? <LocalizedText translationKey={urlTextKey} /> : urlText}</Text.Button>
          </LearnMoreButton>
        </>
      ) : null}
    </Container.Base>
  )
}

export default Oops
